export const APP_ENVIRONMENT = window.APP_ENVIRONMENT;

export const APP_HELP_DESK_URL = window.APP_HELP_DESK_URL;
